/* FAV — başlık arama kutusu için açılır öneri paneli (v28)
   - Shopify Predictive Search: {predictive_search_url}?q=..&section_id=fav-predictive-search
   - 250 ms debounce, en az 2 karakter, ok tuşları / Enter / Esc, mobil uyumlu.
   - Metinler form üzerindeki data-* özniteliklerinden gelir (locale dosyaları). */
(function () {
  'use strict';
  var MIN = 2, DELAY = 250;

  function init(form) {
    if (form.__favSS) return;
    form.__favSS = true;
    var input = form.querySelector('input[name="q"]');
    if (!input) return;
    var url = form.getAttribute('data-suggest-url');
    if (!url) return;
    var d = form.dataset;

    var uid = 'fav-ss-' + Math.random().toString(36).slice(2, 8);
    var panel = document.createElement('div');
    panel.className = 'fav-ss-panel';
    panel.id = uid;
    panel.setAttribute('role', 'listbox');
    panel.setAttribute('aria-label', d.ssLabel || '');
    panel.hidden = true;
    form.appendChild(panel);

    var live = document.createElement('div');
    live.className = 'fav-ss-live';
    live.setAttribute('role', 'status');
    live.setAttribute('aria-live', 'polite');
    form.appendChild(live);

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', uid);
    input.setAttribute('autocomplete', 'off');

    var timer = null, ctrl = null, active = -1, lastQ = '', cache = {};

    function opts() { return panel.querySelectorAll('.fav-ss-opt'); }
    function open() {
      panel.hidden = false;
      form.classList.add('fav-ss-open');
      input.setAttribute('aria-expanded', 'true');
    }
    function close() {
      panel.hidden = true;
      form.classList.remove('fav-ss-open');
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      active = -1;
    }
    function setActive(i) {
      var o = opts();
      if (!o.length) return;
      if (i < 0) i = o.length - 1;
      if (i >= o.length) i = 0;
      o.forEach(function (el, k) {
        var on = k === i;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      active = i;
      input.setAttribute('aria-activedescendant', o[i].id);
      o[i].scrollIntoView({ block: 'nearest' });
    }
    function render(html, q) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var box = tmp.querySelector('.fav-ss');
      if (!box) { close(); return; }
      panel.innerHTML = '';
      box.querySelectorAll('[id^="fav-ss-"]').forEach(function (el) { el.id = uid + '-' + el.id; });
      box.querySelectorAll('[aria-labelledby]').forEach(function (el) {
        el.setAttribute('aria-labelledby', uid + '-' + el.getAttribute('aria-labelledby'));
      });
      panel.appendChild(box);
      active = -1;
      input.removeAttribute('aria-activedescendant');
      var n = parseInt(box.getAttribute('data-count') || '0', 10);
      live.textContent = n > 0 ? (d.ssCount || '') + n : (d.ssEmpty || '');
      open();
    }
    function fetchQ(q) {
      if (cache[q]) { render(cache[q], q); return; }
      if (ctrl) { try { ctrl.abort(); } catch (e) {} }
      ctrl = window.AbortController ? new AbortController() : null;
      var u = url + (url.indexOf('?') > -1 ? '&' : '?') +
        'q=' + encodeURIComponent(q) +
        '&resources%5Btype%5D=product%2Ccollection%2Cpage' +
        '&resources%5Blimit%5D=6&resources%5Blimit_scope%5D=each' +
        '&resources%5Boptions%5D%5Bunavailable_products%5D=last' +
        '&section_id=fav-predictive-search';
      form.classList.add('fav-ss-loading');
      fetch(u, ctrl ? { signal: ctrl.signal, credentials: 'same-origin' } : { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          form.classList.remove('fav-ss-loading');
          cache[q] = html;
          if (input.value.trim() === q) render(html, q);
        })
        .catch(function (e) {
          if (e && e.name === 'AbortError') return;
          form.classList.remove('fav-ss-loading');
          close();
        });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < MIN) {
        lastQ = '';
        if (ctrl) { try { ctrl.abort(); } catch (e) {} }
        close();
        return;
      }
      timer = setTimeout(function () {
        if (q === lastQ && !panel.hidden) return;
        lastQ = q;
        fetchQ(q);
      }, DELAY);
    });
    input.addEventListener('focus', function () {
      if (input.value.trim().length >= MIN && panel.querySelector('.fav-ss')) open();
    });
    input.addEventListener('keydown', function (e) {
      var k = e.key;
      if (k === 'ArrowDown' || k === 'ArrowUp') {
        if (panel.hidden) {
          if (input.value.trim().length >= MIN && panel.querySelector('.fav-ss')) open(); else return;
        }
        e.preventDefault();
        setActive(active + (k === 'ArrowDown' ? 1 : -1));
      } else if (k === 'Enter') {
        var o = opts();
        if (!panel.hidden && active > -1 && o[active]) {
          e.preventDefault();
          window.location.href = o[active].href;
        }
      } else if (k === 'Escape') {
        if (!panel.hidden) { e.preventDefault(); close(); }
      } else if (k === 'Tab') {
        close();
      }
    });
    panel.addEventListener('mousedown', function (e) {
      /* tıklamada input blur olup paneli kapatmasın */
      if (e.target.closest('.fav-ss-opt')) e.preventDefault();
    });
    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) close();
    });
    form.addEventListener('focusout', function () {
      setTimeout(function () { if (!form.contains(document.activeElement)) close(); }, 0);
    });
  }

  function boot() {
    document.querySelectorAll('form.fav-searchbar[data-suggest-url]').forEach(init);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
